export default __webpack_public_path__ + "8d1b3d5638f83585693cdca9e44f84e2.svg";